import { DetailedHTMLProps, HTMLAttributes } from 'react';

import styles from './ContactBubble.module.scss';


type TProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
	classNames?: string[];
};

export function ContactBubble(props: TProps) {
	const {
		children = '',
		className = '',
		classNames: classNamesOuter = [],
		...restProps
	} = props;

	const classNames = [styles.box, ...classNamesOuter];
	if (className) {
		classNames.push(className);
	}

	return (
		<div className={ classNames.join(' ') } { ...restProps }>{ children }!</div>
	);
}
